import { action, flow, flowResult, makeObservable, observable } from "mobx";
import { fetchCollections } from "../../api/ApiManager";
import { ICollection } from "../../entities/Collection/CollectionTypes";
import BusyStore from "../../stores/common/BusyStore";
import raceGuard from "../../utils/raceGuard";

class CollectionOptionsStore extends BusyStore {
  collectionEntry: ICollection | undefined;

  constructor(collectionEntry?: ICollection) {
    super();
    makeObservable<CollectionOptionsStore, "loadCollectionEntryFlow">(this, {
      collectionEntry: observable,

      loadCollectionEntry: action,

      loadCollectionEntryFlow: flow,
    });
    this.collectionEntry = collectionEntry;
  }

  readonly loadCollectionEntry = raceGuard(
    async () => await flowResult(this.loadCollectionEntryFlow())
  );

  private *loadCollectionEntryFlow() {
    this.onLoadingStart();
    try {
      const collectionEntry: ICollection = yield fetchCollections();

      this.collectionEntry = collectionEntry;
    } finally {
      this.onLoadingFinished();
    }
  }
}

export default CollectionOptionsStore;
